<div class="settings-page">
    <div class="content-box">

        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>Decedați</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Decedați</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('indoc-module.persoane-decedate.add')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>

                    <!-- <div class="card-container p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Denumire</mat-label>
                                        <input matInput type="text" formControlName="denumire" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>CNP/CUI</mat-label>
                                        <input matInput type="text" formControlName="cnp_cui" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Tip persoană</mat-label>
                                        <input matInput type="text" formControlName="tip_persoana" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>

                        <div class="row w-100">
                            <div class="col d-flex justify-content-start">
                                <button (click)="toggleCard()" type="button"
                                    class="btn btn-sm btn-warning closeBtn">Închide</button>
                            </div>
                            <div class="col buttons-submit">
                                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                    Resetează
                                </button>
                                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                                    Aplică
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                    </div> -->
                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>